import { createContext, useContext } from "react";

// قيمة افتراضية آمنة: لو مكوّن استُخدم بره شجرة RequierAuth بالغلط،
// بيرجع user: null بدل ما يكسر التطبيق كله بشاشة خطأ
const defaultValue = { user: null, refetchUser: () => { } };

// بيتملى من RequierAuth بعد أول طلب ناجح لـ /user، وبعد كده أي صفحة
// جوه الداشبورد بتاخد البيانات من هنا بدل ما تعمل طلب API من جديد
export const CurrentUserContext = createContext( defaultValue );

export function useCurrentUser ()
{
    return useContext( CurrentUserContext );
}
